"use client";
import * as React from 'react';
import { Role } from '@/types/roles';
import { SignIn } from '@clerk/nextjs';

interface PreceptorTrackLoginFormProps {
  track: string; // np | ap | img
  roleVariant?: Role; // optional more specific role enum
}

export function PreceptorTrackLoginForm({ track }: PreceptorTrackLoginFormProps) {
  // Provide track-specific descriptive text or marketing snippets
  const trackCopy: Record<string, { heading: string; blurb: string; points: string[] }> = {
    np: {
      heading: 'Preceptor Portal – NP Track',
      blurb: 'Mentor Nurse Practitioner trainees, coordinate scope-aligned patient management and document collaborative outcomes.',
      points: ['Scope-Aligned Mentoring', 'Collaborative Care Notes', 'Documentation Oversight']
    },
    ap: {
      heading: 'Preceptor Portal – AP Track',
      blurb: 'Support Accelerated Physician pathway students with procedural exposure and longitudinal competency tracking.',
      points: ['Procedural Scheduling', 'Competency Tracking', 'Evaluation Submissions']
    },
    img: {
      heading: 'Preceptor Portal – IMG Track',
      blurb: 'Guide International Medical Graduates through US system orientation, documentation and interview readiness.',
      points: ['US System Orientation', 'Outcome Documentation', 'Feedback & LOR Strategy']
    },
  };
  const c = trackCopy[track] || trackCopy.img;
  return (
    <div className="grid gap-10 md:grid-cols-2 items-start">
      <div className="space-y-6 md:pr-4">
        <h1 className="text-2xl font-semibold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500">{c.heading}</h1>
        <p className="text-sm text-[var(--brand-muted)] leading-relaxed">{c.blurb}</p>
        <ul className="grid gap-3 text-xs">
          {c.points.map(p => (
            <li key={p} className="flex items-start gap-2">
              <span className="inline-block mt-0.5 h-3 w-3 rounded-full bg-gradient-to-br from-blue-600 to-cyan-500" />
              <span className="text-[var(--brand-muted)]">{p}</span>
            </li>
          ))}
        </ul>
        <p className="text-[10px] uppercase tracking-wide text-[var(--brand-muted)]/70">Track: {track.toUpperCase()}</p>
      </div>
      <div className="max-w-md w-full mx-auto md:mx-0">
        <SignIn
          withSignUp
          routing="path"
          path={`/preceptor/${track}/login`}
          signUpUrl={`/preceptor/${track}/signup`}
          afterSignInUrl="/preceptor/dashboard"
          afterSignUpUrl="/preceptor/profile"
          fallbackRedirectUrl="/preceptor/dashboard"
        />
        {/* <div className="bg-white/95 backdrop-blur-sm border border-[var(--brand-border)] rounded-xl shadow-md p-6 md:p-8">
          <LoginForm role="preceptor" variant="minimal" />
          <div className="mt-4 text-center text-[10px] text-[var(--brand-muted)]">Need access help? <a href="/contact" className="underline">Contact support</a></div>
        </div> */}
      </div>
    </div>
  );
}
export default PreceptorTrackLoginForm;
